import arrowIcon from "@/img/arrow-rigth-icon.svg";

import "./style.scss";

type PrevisionButtonProps = {
	isPrev: boolean;
	isActive: boolean;
	handleClick: (action: "prev" | "next") => void;
};

export const PrevisionButton = ({
	isPrev,
	isActive,
	handleClick,
}: PrevisionButtonProps) => {
	return (
		<button
			className={`prevision-button ${
				!isActive ? "prevision-button-disabled" : ""
			}`}
			onClick={() => handleClick(isPrev ? "prev" : "next")}
		>
			<img
				className={`${isPrev ? "prev" : "next"}`}
				src={arrowIcon}
				alt={`${isPrev ? "previous" : "next"}`}
			/>
		</button>
	);
};

export default PrevisionButton;
